import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import SimpleHeader from '../../main/headers/simpleHeader';
import LoansTable from './LoansTableContainer';
import { LOANS_FILTER } from '../constants';
import { t } from '../../../modules/infra/i18n';

const Loans = ({ filter, selectFilter, filteredLoans }) => (
  <div>
    <SimpleHeader heading={t('loans:list.header')} />
    <div className="c-wrapper o-page-height">
      <div className="c-form-input-group">
        <div className="c-form-input-group__item">
          <button
            className={classnames('c-btn c-btn--outline c-btn--medium c-btn--active-branding', {
              'is-active': filter === LOANS_FILTER.ALL,
            })}
            type="button"
            onClick={selectFilter(LOANS_FILTER.ALL)}
            data-automation-id="loans-filter-all"
          >
            {t('loans:list.filter_all')}
          </button>
        </div>
        <div className="c-form-input-group__item">
          <button
            className={classnames('c-btn c-btn--outline c-btn--medium c-btn--active-branding', {
              'is-active': filter === LOANS_FILTER.IN_PROGRESS,
            })}
            type="button"
            onClick={selectFilter(LOANS_FILTER.IN_PROGRESS)}
            data-automation-id="loans-filter-in-progress"
          >
            {t('loans:list.filter_in_progress')}
          </button>
        </div>
        <div className="c-form-input-group__item">
          <button
            className={classnames('c-btn c-btn--outline c-btn--medium c-btn--active-branding', {
              'is-active': filter === LOANS_FILTER.PAID,
            })}
            type="button"
            onClick={selectFilter(LOANS_FILTER.PAID)}
            data-automation-id="loans-filter-paid"
          >
            {t('loans:list.filter_paid')}
          </button>
        </div>
      </div>

      <LoansTable loans={filteredLoans} />

      <div className="u-fontsize-extrasmall u-mt">{t('loans:list.footer_disclaimer')}</div>
    </div>
  </div>
);

Loans.propTypes = {
  filter: PropTypes.oneOf(Object.values(LOANS_FILTER)).isRequired,
  selectFilter: PropTypes.func.isRequired,
  filteredLoans: PropTypes.array.isRequired,
};

export default Loans;
